import { render, staticRenderFns } from "./AuthorizationCollection.vue?vue&type=template&id=06c5ecc0&scoped=true"
import script from "./AuthorizationCollection.vue?vue&type=script&lang=js"
export * from "./AuthorizationCollection.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationCollection.vue?vue&type=style&index=0&id=06c5ecc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5ecc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c5ecc0')) {
      api.createRecord('06c5ecc0', component.options)
    } else {
      api.reload('06c5ecc0', component.options)
    }
    module.hot.accept("./AuthorizationCollection.vue?vue&type=template&id=06c5ecc0&scoped=true", function () {
      api.rerender('06c5ecc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/AuthorizationCollection.vue"
export default component.exports